import { combineReducers } from 'redux';
import { listJobsReducer } from './list-jobs';

export default combineReducers({
  listJobs: listJobsReducer,
});
